import { httpGet } from '../../common/util'

export const querySeckillStatus = (goodsId, activityType, activityId) => {
    return httpGet({
        url: '/activity/flashSale/getDiscountPrice',
        data: {
            goodsId,
            activityId,
            activityType
        }
    })
}

export const queryAreaInfo = (goodsId) => {
    return httpGet({
        url: '/stock/queryAreaServerInfo',
        data: {
            goodsId
        }
    })
}
